module.exports = __webpack_public_path__ + "fonts/eabb971f93f6b5b9a3532e964a77621a.txt";